VjsAdmin.auditGoogleMapping = (function () {
    const districtGuid = $('.district-info').data('district-guid');
    const platformId = $('.platform-info').data('platform-id');
    const init = function () {
        new AuditClickEvent();
    };

    const AuditClickEvent = VjsUtility.Controller.extend({
        events: {
            'click #audit-mappings': 'clickAuditMappings',
        },
        clickAuditMappings() {
            const resultsView = new AuditResultsView();
            resultsView.fetch();
        },
    });

    const AuditResultsView = VjsUtility.View.extend({
        parent: '#audit-mappings-results',
        templateUrl: '/assets/templates/google/mapping/audit-results-component.html',
        dataUrl: `/platforms/${platformId}/districts/${districtGuid}/google/audit/results`,
        after(res) {
            console.log(res);
        },
    });

    return {
        init,
    };
}());
